const ErrorMessage = ({ error }) => {
  return <div className="Error">{error}</div>;
};

export default ErrorMessage;
